module.exports = __webpack_public_path__ + "static/img/cd_yd.1dcafc3f.png";